import React from 'react';
import { overlayArrowStyles } from './overlay-arrow.styles.esm.js';
import { OverlayArrow as _OverlayArrow } from '../popover/aria/overlay-arrow.esm.js';
import { usePopoverContext } from '../popover/popover-context.esm.js';

var OverlayArrow = function OverlayArrow() {
  var _usePopoverContext = usePopoverContext(),
    color = _usePopoverContext.color;
  var classes = overlayArrowStyles({
    color: color
  });
  return /*#__PURE__*/React.createElement(_OverlayArrow, {
    className: "group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "csg-tw-overlay-arrow ".concat(classes)
  }));
};

export { OverlayArrow as default };
//# sourceMappingURL=overlay-arrow.esm.js.map
